import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, Box, Button, IconButton, TextField, Menu, MenuItem, Divider, InputAdornment, Chip, Modal, Typography,} from "@mui/material";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { esignIcons } from "../Esign/icons";
import AddProduct from "./addProduct";
import { developerTollApi } from "../../services/developerTollApi";

const AllProductsTable = ({allProducts, setSelectedProduct, selectedProduct, setOpenEditor, openEditor, setProductEdit, productEdit, fetchAllProducts}) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const { open } = useOutletContext();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [deleteProductOpen, setDeleteProductOpen] = useState(false);

    const handleMenuOpen = (event, product) => {
        setMenuAnchorEl(event.currentTarget);
        console.log(product)
        setSelectedProduct(product);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setSelectedProduct(null);
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const handleDelete = () => {
        setDeleteProductOpen(true);
        setMenuAnchorEl(null);
    };

    const handleDeleteProduct = async () => {
        try {
            console.log(selectedProduct)
            const payload ={
                product_id: selectedProduct.product_id
            }
            const response = await developerTollApi.deleteProduct(payload);
            console.log("API Response:", response);
    
            if (response?.status) {
                setDeleteProductOpen(false);
                setSelectedProduct(null);
                fetchAllProducts();
            } else {
                console.error("Failed to delete signer:", response);
            }
        } catch (error) {
            console.error("Error deleting signer:", error);
        }
    };

  const filteredDocs = allProducts.filter(
    (doc) =>
      doc.product_name.toLowerCase().includes(searchText.toLowerCase()) ||
      (doc.description || "").toString().toLowerCase().includes(searchText.toLowerCase()) ||
      (doc.mapped_product_name || "").toString().toLowerCase().includes(searchText.toLowerCase())
  );
  
  return (
    <>
        <Box sx={{ display: "flex", p: "15px 25px", justifyContent: "space-between", alignItems: "center", }}>
            <TextField
                placeholder="Search..."
                type="text"
                variant="outlined"
                onChange={handleSearchChange}
                sx={{
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#E8E8E9",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                    borderColor: "#E8E8E9",
                    backgroundColor: "none",
                    "&:hover fieldset": {
                    borderColor: "#E8E8E9",
                    },
                    "&.Mui-focused fieldset": {
                    borderColor: "#E8E8E9",
                    },
                },
                "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                },
                }}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    {esignIcons.searchIcon}
                    </InputAdornment>
                ),
                sx: { 
                    borderRadius: "10px",
                    width: 410,
                    height: 40,
                    fontSize: "16px",
                    fontWeight: "500",
                    "& input::-ms-reveal, & input::-ms-clear": {
                        display: "none",
                    },
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                        display: "none",
                        WebkitAppearance: "none",
                        margin: 0,
                    },
                    "& input[type=number]": {
                        MozAppearance: "textfield",
                    },
                },
                }}
            />
        </Box>
        <Paper sx={{ width: "100%", overflow: "auto", boxShadow: "none", height: "85%", }}>
            <TableContainer>
                <Table>
                <TableHead sx={{ background: "#F5F5F5", fontSize: "15px", fontWeight: 500, color: "#1D1D1D" }}>
                    <TableRow>
                    <TableCell sx={{  pl: "30px", }}>S. No.</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Mapped Product</TableCell>
                    <TableCell>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {filteredDocs.length > 0 ? (
                    [...filteredDocs]
                    .reverse()
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                        <TableRow key={row.product_id} sx={{ "&:hover": { backgroundColor: "#fafafa",}}}>
                            <TableCell sx={{ pl: "30px", cursor: "pointer" }}>{(page * rowsPerPage + index + 1).toString().padStart(2, "0")}</TableCell>
                            <TableCell sx={{ cursor: "pointer" }}>
                                {row.product_name}
                            </TableCell>
                            <TableCell sx={{ cursor: "pointer" }}>
                                {row.is_public ? <Chip label="Public" color="success" size="small" /> : <Chip label="Private" color="error" size="small" />}
                            </TableCell>
                            <TableCell sx={{ cursor: "pointer" }}>
                                {row.mapped_product_name || "-"}
                            </TableCell>
                            <TableCell onClick={(e) => e.stopPropagation()} >
                                <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                {esignIcons.moreIcon}
                                </IconButton>
                            </TableCell>
                        </TableRow>
                        ))
                    ) : (
                    <TableRow>
                        <TableCell colSpan={5} align="center">
                        No products found
                        </TableCell>
                    </TableRow>
                    )}
                </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10]}
                component="div"
                count={filteredDocs.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(event) =>
                    setRowsPerPage(parseInt(event.target.value, 10))
                }
            />
        </Paper>

        <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
            sx: {
                height: "83px",
                width: "118px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                overflow: "hidden",
                alignItems: "center",
            },
        }}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center", 
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        >
            <MenuItem onClick={() => {setOpenEditor(true); setMenuAnchorEl(null); setProductEdit(true);}} sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt: 0, "&:hover": { background: "transparent",} }}>{esignIcons.editIcon} Edit</MenuItem>
            <Divider />
            <MenuItem onClick={handleDelete} sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt: 0, "&:hover": { background: "transparent",} }}>{esignIcons.delteIcon} Delete</MenuItem>
        </Menu>

        <AddProduct openEditor={openEditor} handleClose={() => setOpenEditor(false)} selectedProduct={selectedProduct} allProducts={allProducts} productEdit={productEdit} fetchAllProducts={fetchAllProducts}/>

        <Modal open={deleteProductOpen} onClose={() => setDeleteProductOpen(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "434px",
                    height: "368px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "auto",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                    <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Delete Signer</Typography>
                </Box>
                <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                <Box sx={{ p: "1em 2em", mb: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "74%" }}>
                    <Box>
                        <img src={`${process.env.PUBLIC_URL}/images/delete.gif`} alt="delete" style={{ height: 83 }} />
                    </Box>
                    <Typography variant="p" sx={{ fontSize: "20px", fontWeight: 400, color: "#1D1D1D" }}>Are you sure you want to delete this user?</Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: "auto", gap: 2 }}>
                        <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => setDeleteProductOpen(false)} >
                            No
                        </Button>
                        <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#C5060B", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #C5060B", boxShadow: "none", fontWeight: "500",}} onClick={handleDeleteProduct} >
                            Delete
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    </>
  );
};

export default AllProductsTable;
